
export enum CollectionChangeExecutionStatus {
    Pending = "pending",
    Success = "success",
    Failed = "failed",
    Skipped = "skipped"
}



export interface CollectionChangeExecutionOutcome{
    totalDocumentCount: number;
    elapsedTime: number;
    status: CollectionChangeExecutionStatus;
    message?: string;
    collectionName?: string;
}